import { DEFAULT_DATE_FORMAT } from '@shared/utils'
import { DatePicker, Form } from 'antd'

import { TaskFormElement } from './types'

type Props = {
  element: TaskFormElement
  required?: boolean
}

export const DateElement = ({ element, required }: Props) => {
  return (
    <Form.Item name={element.name} label={element.label} rules={[{ required }]}>
      <DatePicker format={DEFAULT_DATE_FORMAT} />
    </Form.Item>
  )
}
